import React from 'react';
import { RadioButtonPropsType } from '@insurancemenu/imenu-components-lib/dist/types';
import { RadioButtonStyled } from './styles';

export const ChooseSourceRadioButton: React.FC<RadioButtonPropsType> = ({ ...props }) => {
  return <RadioButtonStyled {...props} />;
};
